module.exports = __webpack_public_path__ + "static/media/2019-04-12-01.e19162c6.jpg";